import { Injectable } from '@angular/core';
import Sockette from 'sockette';
import { CONNECTION_SOCKET_TIMEOUT, MAX_ATTEMPTS_SOCKET_RECONNECT } from './config.service';
import { SOCKET_URL, SERVER_URL } from 'src/environments/environment';
import { Observable, interval, Subject, Subscription } from 'rxjs';
import { timeout } from 'q';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class SocketService {

  DEFAULT_TIMEOUT: number = 30;
  alerts: any = [];
  number_alerts: any = 0;


  protected webSocket: Sockette;
  isSocketConnected: boolean = false;
  pingInterval: any;

  constructor(public authService: AuthService, public http: HttpClient) {
    this.connectSocket();
  }

  // Connect to web socket
  protected async connectSocket() {

    var playerData = await this.authService.getPlayerInitialData()
    if (!playerData) return null;
    this.webSocket = new Sockette(SOCKET_URL + "?token=" + this.authService.USER_TOKEN + "&u_id=" + playerData.user.id,
      {
        timeout: CONNECTION_SOCKET_TIMEOUT,
        maxAttempts: MAX_ATTEMPTS_SOCKET_RECONNECT,
        onopen: e => this.onConnectedSocket(e),
        onmessage: e => this.onMessage(e),
        onreconnect: e => console.warn('[Socket] Reconnecting...', e),
        onmaximum: e => console.warn('[Socket] Stop Attempting!', e),
        onclose: e => console.warn('[Socket] Closed!', e),
        onerror: e => console.error('[Socket] Error:', e)
      });

    // Reconnect 10s later
    //setTimeout(ws.reconnect, 10e3);
    return this.webSocket;
  }

  onConnectedSocket(event) {
    this.isSocketConnected = true;
    console.debug('Socket conected!', event);
    this.startPingInterval();
    // On first connection try to reload recent rooms
    // this.events.publish('reload::rooms');
  }

  startPingInterval() {
    // Now update it every 45 seconds
    let reload = interval(1000 * 45);
    this.pingInterval = reload.subscribe(x => {
      this.pingToServer();
    });
  }

  pingToServer() {
    this.webSocket.send(JSON.stringify({ "action": "ping" }));
  }

  onMessage(event) {
    let data = JSON.parse(event.data);
    console.debug('Socket::Received:', data);
    if (data.notification) this.addNotification(data);
  }

  addNotification(notification) {
    var player_alert = {
      alert: {
        alert_type: notification.type,
        title: notification.title,
        description: notification.description,
        mission: notification.mission_id,
        order: notification.order_id,
        promotion: notification.promotion_id,
        response: notification.response_id,
        created: notification.created
      },
      id: notification.notification,
      was_seen: false
    }
    this.alerts.unshift(player_alert);
    this.number_alerts += 1;
  }


  getPlayerAlerts(offset = "0", limit = "5"): Promise<any> {
    const url = SERVER_URL + '/alerts/player_alerts/'
    const params = { limit, offset }
    const headers = this.authService.getSimpleAuthHeaders();
    return this.http.get(url, { headers, params }).toPromise();
  }

  getNumberAlerts() {
    const url = SERVER_URL + '/alerts/get_number_of_alerts/'
    const headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise();
  }

  markAsSeen(player_alert_id) {
    const url = SERVER_URL + '/alerts/mark_as_seen/'
    const headers = this.authService.getAuthHeaders();
    const body = { player_alert_id }
    return this.http.post(url, body, headers).toPromise();
  }
}
